document.addEventListener('DOMContentLoaded', function () {
  const volumeToggle = document.getElementById('volumeToggle');
  const volumeInput = document.getElementById('volume');
  const resultDiv = document.getElementById('result');
  const calculateButton = document.getElementById('calculateButton');
  const currentCaInput = document.getElementById('currentCa');
  const desiredCaInput = document.getElementById('desiredCa');
  const productSelect = document.getElementById('product');

  if (
    !volumeToggle ||
    !volumeInput ||
    !resultDiv ||
    !calculateButton ||
    !currentCaInput ||
    !desiredCaInput ||
    !productSelect
  ) {
    console.error('Required elements not found:', {
      volumeToggle,
      volumeInput,
      resultDiv,
      calculateButton,
      currentCaInput,
      desiredCaInput,
      productSelect
    });
    return;
  }

  function updateVolumePlaceholder() {
    volumeInput.placeholder = volumeToggle.checked
      ? 'Enter volume in liters'
      : 'Enter volume in gallons';
  }

  function showResult(message) {
    resultDiv.innerHTML = message;
    resultDiv.classList.add('show');
  }

  function calculateDose() {
    const volume = parseFloat(volumeInput.value) || 0;
    const isLiters = volumeToggle.checked;
    const currentCa = parseFloat(currentCaInput.value || 0);
    const desiredCa = parseFloat(desiredCaInput.value || 0);
    const product = productSelect.value || 'brightwell';

    if (isNaN(volume) || volume <= 0) {
      showResult('Please enter a valid aquarium volume greater than 0.');
      return;
    }

    if (isNaN(currentCa) || currentCa < 200 || currentCa > 600) {
      showResult('Current calcium level must be between 200 and 600 ppm.');
      return;
    }

    if (isNaN(desiredCa) || desiredCa < 200 || desiredCa > 600) {
      showResult('Desired calcium level must be between 200 and 600 ppm.');
      return;
    }

    if (desiredCa <= currentCa) {
      showResult('Desired calcium level must be higher than current level.');
      return;
    }

    let volumeGallons;
    if (isLiters) {
      volumeGallons = volume / 3.785;
    } else {
      volumeGallons = volume;
    }

    const caIncrease = desiredCa - currentCa;

    const products = {
      redsea: { name: 'Red Sea Reef Foundation A (Ca/Sr)', ppmPerMl: 52.85 },
      brightwell: { name: 'Brightwell Reef Code A', ppmPerMl: 16 },
      fauna: { name: 'Fauna Marin ELEMENTALS (Ca/Sr)', ppmPerMl: 50.2 },
      tropicmarin: { name: 'Tropic Marin Balling Part A (Dry)', ppmPerMl: 5 },
      fritz: { name: 'Fritz RPM Liquid Calcium Elements Part 2', ppmPerMl: 15 },
      oceanblend: { name: 'Ocean Blend Calcium', ppmPerMl: 10 },
      esv: { name: 'ESV B-Ionic Component NO.2', ppmPerMl: 16 },
      tlf: { name: 'Two Little Fishies C-Balance Part A', ppmPerMl: 10 }
    };

    const selectedProduct = products[product] || products.brightwell;
    const totalDosageMl = (caIncrease * volumeGallons) / selectedProduct.ppmPerMl;

    const flOz = totalDosageMl / 29.5735;
    const tsp = totalDosageMl / 5;

    let resultHtml = `Total required dose: <strong>${totalDosageMl.toFixed(1)} mL</strong><br>${flOz.toFixed(1)} fl oz or ${tsp.toFixed(1)} tsp for the entire tank`;

    if (caIncrease > 40) {
      const days = [2, 3, 4];
      resultHtml += '<br><strong>Suggestion:</strong> For safety, split this dose over multiple days:<ul>';
      days.forEach(function (day) {
        const dailyDose = totalDosageMl / day;
        resultHtml += `<li>${day} days: ${dailyDose.toFixed(1)} mL per day</li>`;
      });
      resultHtml += '</ul>';
    }

    showResult(resultHtml);
  }

  volumeToggle.addEventListener('change', function () {
    updateVolumePlaceholder();
    const volumeValue = parseFloat(volumeInput.value) || 0;
    if (!isNaN(volumeValue) && volumeValue > 0) {
      calculateDose();
    }
  });

  calculateButton.addEventListener('click', calculateDose);
  volumeInput.addEventListener('input', calculateDose);
  currentCaInput.addEventListener('input', calculateDose);
  desiredCaInput.addEventListener('input', calculateDose);
  productSelect.addEventListener('change', calculateDose);

  updateVolumePlaceholder();
});